export default {"src":"/_next/static/media/logo_affinita.fc28c027.svg","height":25,"width":122,"blurWidth":0,"blurHeight":0};